import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Region } from '@api/types/Region';



interface RegionItemProps {
	selectedRegion: string,
	region: Region,
}


const RegionItem = (props: RegionItemProps) => {
	const { selectedRegion, region } = props;
	const { t } = useTranslation('web');

	if (selectedRegion !== '' && selectedRegion !== region.key) return null;


	if (selectedRegion === '' && (!region.clinics || region.clinics.length === 0)) return null;


	if (selectedRegion === region.key && (!region.clinics || region.clinics.length === 0)) return (
		<div className='region-item'>
			<h2>{region.name}</h2>
			
			<div className='region-clinics'>
				<p className='empty-link'>
					{t('pages.salesNetwork.emtyMessage')}
				</p>
			</div>
		</div>
	)

	return (
		<div className='region-item'>

			<h2>{region.name}</h2>
			
			<div className='region-clinics'>

				{region.clinics.map(x =>
					<Link to={x.link}
						className='disable-selection'
						target='_blank'
						rel='noopener noreferrer'
						key={`region-clinics-${x.name}`}>
							{x.name}
					</Link>)}
			
			</div>
		</div>
	);
};

export default RegionItem;